import { MAX_LUMINANCE_FOR_LIGHT_TEXT } from '@lib/constants/color.const'
import type { Range } from './tsHelpers'

export const isValidHex = (color = '') => /^#[0-9A-F]{6}$/i.test(color)

export function getLuminance(color: string): number {
  if (!color) return 0
  const hex = color.replace('#', '')

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  return r * 0.299 + g * 0.587 + b * 0.114
}

export function getContrastTextColor(backgroundColor: string): string {
  const luminance = getLuminance(backgroundColor)
  return luminance < MAX_LUMINANCE_FOR_LIGHT_TEXT ? '#ffffff' : '#000000'
}

export const stringToHslColor = (str: string, s: Range<0, 100> = 55, l: Range<0, 100> = 75) => {
  let hash = 0

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  const h = hash % 360

  return `hsl(${h}, ${s}%, ${l}%)`
}
